module.exports = __webpack_public_path__ + "static/media/arteycultura.157ab2fb.png";